/* eslint-disable no-console */
/* eslint-disable prefer-destructuring */

function buildPaginationLinks(links, names) {
  let prevLink;
  let nextLink;
  let prevName;
  let nextName;
  let i;
  if (window.location.pathname.endsWith('/')) {
    i = links.indexOf(window.location.pathname);
  } else {
    i = links.indexOf(`${window.location.pathname}/`);
  }

  if (i === 0) {
    prevLink = links[links.length - 1];
    prevName = names[names.length - 1];
    nextLink = links[i + 1];
    nextName = names[i + 1];
  } else if (i === links.length - 1) {
    prevLink = links[i - 1];
    prevName = names[i - 1];
    nextLink = links[0];
    nextName = names[0];
  } else {
    prevLink = links[i - 1];
    prevName = names[i - 1];
    nextLink = links[i + 1];
    nextName = names[i + 1];
  }
  // console.log({ prevLink, prevName, nextLink, nextName });
  return { prevLink, prevName, nextLink, nextName };
}

const buildPaginationHtml = () => {
  const mainContent = document.querySelector('.colorbook-main-content');
  const links = document.querySelectorAll('.sidebar-nav .nav-item a');
  // console.log('links:', links);
  const linkPaths = [...links].map(x => x.attributes.href.nodeValue);
  // console.log('linkPaths:', linkPaths);
  const linkNames = [...links].map(x => x.textContent);
  const paginationLinks = buildPaginationLinks(linkPaths, linkNames);
  window.linkPaths = linkPaths;
  const paginationHtml = `
      <div class="color-book-pagination">
         <div class="prev">
           <a href="${paginationLinks.prevLink}">
             <div class="page-arrow">&lsaquo;</div> ${paginationLinks.prevName}
           </a>
         </div>
         <div class="prev">
           <a href="${paginationLinks.nextLink}">
             ${paginationLinks.nextName} <div class="page-arrow">&rsaquo;</div>
           </a>
         </div>
      </div>
  `;
  mainContent.insertAdjacentHTML('afterbegin', paginationHtml);
};


// Side bar nav functionality

function navAccordion(e) {
  e.stopPropagation();
  // console.log(this);
  this.classList.toggle('active');
}

const attachNavEvents = (navSection) => {
  const navBarHeadings = document.querySelectorAll(navSection);
  const links = document.querySelectorAll('.nav-section-heading > a');
  navBarHeadings.forEach(item => item.addEventListener('click', navAccordion));
  links.forEach(item => item.addEventListener('click', (e) => {
    e.preventDefault();
  }));
};

const resizeSliderArrows = () => {
  const slider = document.querySelector('.multi-item-swatch-carousel');
  const arrows = slider.querySelectorAll('.slick-arrow');
  const elToFollow = slider.querySelector('.slider-image');
  const elHeight = elToFollow.clientHeight;
  const topOffset = Math.floor(elHeight / 2);
  arrows.forEach((arrow) => {
    // console.log(elHeight);
    arrow.style.height = `${elHeight}px`;
    arrow.style.top = `${topOffset}px`;
  });
};

export {
  buildPaginationHtml,
  attachNavEvents,
  resizeSliderArrows,
};

/* eslint-enable no-console */
/* eslint-enable prefer-destructuring */
